import './static/css/bootstrap.css'
import './static/css/all.css' // Font-Awesome-Icons-CSS
import './static/css/fonts.css' // Web Fonts
import './static/css/style.css' // web page style
import './static/css/responsive.css' // for mobile screen
import './static/css/admin.css' // Roles admin styles
import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { CartProvider } from 'use-shopping-cart'

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_API_PUBLIC)

export const wrapRootElement = ({ element }) => {
  return (
    <CartProvider mode="checkout-session" stripe={stripePromise} currency="USD">
      {element}
    </CartProvider>
  )
}
